<template>
  <div class="type-of-review wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label" style="margin-bottom: 20px"
          >管理费分成整体配置</label
        >
        <Form class="content-box">
          <FormItem label="我的管理费比例：" prop="keepRate" style="display: flex">
            <label v-if="!readonly">{{ feeData.keepRate }}%</label>
            <Input
              v-model="feeData.keepRate"
              placeholder="请输入我的管理费比例"
              v-if="readonly"
              @on-change="changeRate()"
            ></Input>
          </FormItem>
          <FormItem
            label="下级接收单位管理费比例："
            prop="shareRate"
            style="display: flex"
          >
            <label>{{ feeData.shareRate }}%</label>
          </FormItem>
          <Button type="primary" @click="saveConfig()" v-if="!readonly">修改</Button>
          <Button type="primary" @click="saveConfig()" v-if="readonly">确认</Button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
// 管理费分配
export default {
  name: 'administrativeFee',
  data () {
    return {
      readonly: false, // 是否可修改
      feeData: {
        keepRate: '',
        shareRate: ''
      }
    };
  },
  created () {
    this.getUserFeeRate();
  },
  methods: {
    getUserFeeRate () {
      this.post('/school/schoolDegreeOffice/getUserFeeRate').then((res) => {
        this.feeData.keepRate = res.data.keepRate;
        this.feeData.shareRate = res.data.shareRate;
      })
    },
    saveConfig () {
      this.readonly = !this.readonly;
      if (!this.readonly) {
        let params = this.feeData;
        this.post('/school/schoolDegreeOffice/updateUserFeeRate', params).then((res) => {
          this.feeData.keepRate = res.data.keepRate;
          this.feeData.shareRate = res.data.shareRate;
        })
      }
    },
    changeRate () {
      var reg = new RegExp('^(\\d|[1-9]\\d|100)$');
      if (!reg.test(this.feeData.keepRate)) {
        this.$Message.warning('请输入0-100的整数')
      } else {
        this.feeData.shareRate = 100 - this.feeData.keepRate;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.content-box {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/layout/customPage/thesisManage/administrativeFee.vue